import { render, staticRenderFns } from "./roomWatcherNoPic.vue?vue&type=template&id=05dd8b92&"
import script from "./roomWatcherNoPic.vue?vue&type=script&lang=js&"
export * from "./roomWatcherNoPic.vue?vue&type=script&lang=js&"
import style0 from "./roomWatcherNoPic.vue?vue&type=style&index=0&id=05dd8b92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports